export default {"src":"/_next/static/media/funds.36101db6.svg","height":37,"width":41};